/**
 * Módulo testable del step 5 PIN (countdown + resend) — DEO-366 / CVC-3.
 * Consumido por cv-creator.js y por Jest + jsdom.
 */
(function (global) {
    'use strict';

    function buildSendConfirmationPinParam(candidateId) {
        return JSON.stringify({
            site: 'talento',
            msg: 'sendConfirmationPin',
            fields: { candidate_id: String(candidateId) }
        });
    }

    function buildCountdownTimerHtml(minutes, seconds) {
        return 'Reenviar en <span class="minutes">' + minutes + '</span>:<span class="seconds">' + seconds + '</span>';
    }

    function buildRequestNewPinHtml() {
        return '<a href="#" class="requestNewPIN">Solicitar nuevo PIN</a>';
    }

    /**
     * @param {object} utils - cvcreator* helpers from cv-creator-utils.js
     * @param {object} deps - clearInterval, setInterval, document, setTimerHtml(html)
     */
    function createPinStep5Module(utils, deps) {
        var pinClockController = utils.cvcreatorCreatePinClockController(
            deps.clearInterval,
            deps.setInterval
        );

        function getTimeRemaining(endtime) {
            return utils.cvcreatorGetTimeRemaining(endtime, deps.nowDate);
        }

        function initializeClock(clockId, endtime) {
            var clock = deps.document.getElementById(clockId);
            if (!clock) {
                return;
            }

            var minutesSpan = clock.querySelector('.minutes');
            var secondsSpan = clock.querySelector('.seconds');
            if (!minutesSpan || !secondsSpan) {
                return;
            }

            function updateClock() {
                var t = getTimeRemaining(endtime);

                minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
                secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

                if (t.total <= 0) {
                    pinClockController.stop();
                }

                if (utils.cvcreatorShouldShowRequestNewPin(t.minutes, t.seconds)) {
                    deps.setTimerHtml(buildRequestNewPinHtml());
                }
            }

            pinClockController.start(updateClock, 1000);
        }

        function applyResendPinResponse(data, isSuccess) {
            var cooldownSeconds = utils.cvcreatorParseRetryAfter(data, 120);
            var parts = utils.cvcreatorFormatPinCountdown(cooldownSeconds);

            if (isSuccess) {
                return {
                    cooldownSeconds: cooldownSeconds,
                    timerHtml: buildCountdownTimerHtml(parts.minutes, parts.seconds),
                    toastMessage: 'Nuevo PIN enviado al correo electrónico'
                };
            }

            if (data && data.retry_after) {
                return {
                    cooldownSeconds: cooldownSeconds,
                    timerHtml: buildCountdownTimerHtml(parts.minutes, parts.seconds),
                    toastMessage: data.msg || 'No se pudo reenviar el PIN.'
                };
            }

            return {
                cooldownSeconds: cooldownSeconds,
                timerHtml: null,
                toastMessage: (data && data.msg) ? data.msg : 'No se pudo reenviar el PIN.'
            };
        }

        function applyResendPinFailResponse(data, statusCode) {
            var isCooldown = Number(statusCode) === 429;
            var cooldownSeconds = isCooldown ? utils.cvcreatorParseRetryAfter(data, 120) : 0;

            if (!isCooldown) {
                return {
                    cooldownSeconds: cooldownSeconds,
                    timerHtml: null,
                    toastMessage: (data && data.msg) ? data.msg : 'No se pudo reenviar el PIN.'
                };
            }

            var parts = utils.cvcreatorFormatPinCountdown(cooldownSeconds);
            return {
                cooldownSeconds: cooldownSeconds,
                timerHtml: buildCountdownTimerHtml(parts.minutes, parts.seconds),
                toastMessage: (data && data.msg) ? data.msg : 'Espera antes de solicitar un nuevo PIN.'
            };
        }

        /**
         * Enlaza el click handler de .requestNewPIN (testeable con jQuery mock — CVC-3).
         */
        function bindRequestNewPinClick(deps) {
            deps.$(document).on('click', deps.clickSelector, function (e) {
                e.preventDefault();

                var candidate_id = deps.$(deps.candidateIdSelector).val();
                var param = buildSendConfirmationPinParam(candidate_id);

                deps.$(deps.timerSelector).html('Procesando nuevo PIN...');

                deps.$.post(deps.apiUrl, { param: param }).done(function (data) {
                    var result = applyResendPinResponse(data, data.status == 1);
                    deps.showToast(result.toastMessage);

                    if (result.timerHtml) {
                        deps.$(deps.timerSelector).html(result.timerHtml);
                        var deadline = new Date(Date.parse(new Date()) + result.cooldownSeconds * 1000);
                        deps.initializeClock(deps.clockId, deadline);
                    }
                }).fail(function (jqXHR) {
                    var data = jqXHR.responseJSON || {};
                    var result = applyResendPinFailResponse(data, jqXHR.status);
                    deps.showToast(result.toastMessage);

                    if (result.timerHtml) {
                        deps.$(deps.timerSelector).html(result.timerHtml);
                        var deadline = new Date(Date.parse(new Date()) + result.cooldownSeconds * 1000);
                        deps.initializeClock(deps.clockId, deadline);
                    }
                });

                return false;
            });
        }

        return {
            buildSendConfirmationPinParam: buildSendConfirmationPinParam,
            buildCountdownTimerHtml: buildCountdownTimerHtml,
            buildRequestNewPinHtml: buildRequestNewPinHtml,
            initializeClock: initializeClock,
            applyResendPinResponse: applyResendPinResponse,
            applyResendPinFailResponse: applyResendPinFailResponse,
            bindRequestNewPinClick: bindRequestNewPinClick,
            getClockController: function () {
                return pinClockController;
            }
        };
    }

    var pinApi = {
        buildSendConfirmationPinParam: buildSendConfirmationPinParam,
        buildCountdownTimerHtml: buildCountdownTimerHtml,
        buildRequestNewPinHtml: buildRequestNewPinHtml,
        createPinStep5Module: createPinStep5Module,
        bindRequestNewPinClick: function (deps) {
            return createPinStep5Module(deps.utils, {
                clearInterval: deps.clearInterval,
                setInterval: deps.setInterval,
                document: deps.document,
                nowDate: deps.nowDate,
                setTimerHtml: deps.setTimerHtml
            }).bindRequestNewPinClick(deps);
        }
    };

    if (typeof module === 'object' && module.exports) {
        module.exports = pinApi;
    }

    if (global) {
        global.cvcreatorBuildSendConfirmationPinParam = buildSendConfirmationPinParam;
        global.cvcreatorCreatePinStep5Module = createPinStep5Module;
    }
}(typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : this));
